/// <reference types="vite-plugin-svgr/client" />
import { createRoot } from "react-dom/client";
import "@/index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import RootRouter from "./routes/RootRouter";
import { lazy } from "react";
import AuthRoute from "./routes/AuthRoute";
import ProjectRoute from "./routes/ProjectRoute";
import AdminRoute from "./routes/AdminRoute"; // Add this

const LandingPage = lazy(() => import("@/components/pages/LandingPage"));
const NotFoundPage = lazy(() => import("@/components/pages/NotFoundPage"));
const MapPage = lazy(() => import("@/components/pages/MapPage"));
const LogInPage = lazy(() => import("@/components/pages/LogInPage"));
const SignUpPage = lazy(() => import("@/components/pages/SignUpPage"));
const ProjectsPage = lazy(() => import("@/components/pages/ProjectsPage"));
const AdminPage = lazy(() => import("@/components/pages/AdminPage")); // Add this
const ForgotPasswordPage = lazy(
  () => import("@/components/pages/ForgotPasswordPage")
);
const ResetPasswordPage = lazy(
  () => import("@/components/pages/ResetPasswordPage")
);
const ConfirmEmailPage = lazy(
  () => import("@/components/pages/ConfirmEmailPage")
);

const queryClient = new QueryClient();

const router = createBrowserRouter(
  createRoutesFromElements([
    <Route element={<RootRouter />} errorElement={<NotFoundPage />}>
      <Route path="/" element={<LandingPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/login" element={<LogInPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/confirm-email" element={<ConfirmEmailPage />} />
      <Route element={<AuthRoute />}>
        <Route path="/projects" element={<ProjectsPage />} />
        <Route element={<ProjectRoute />}>
          <Route path="projects/:id/map" element={<MapPage />} />
        </Route>
        {/* Add admin route */}
        <Route element={<AdminRoute />}>
          <Route path="/admin" element={<AdminPage />} />
        </Route>
      </Route>
    </Route>,
  ])
);

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);
